module.exports = __webpack_public_path__ + "img/clock-and-rose-tattoo-by-Andres-Acosta.jpg";